export const passwordRegEx =
  ///^(?=.*[A-Z])(?=.*[a-z])(?=.*[\d.!@#$%^&*()\-_])[\w\d\-.!@#$%^&*()]{6,}$/;
  /^(?=.*[A-Za-z])(?=.*[\d.!@#$%^&*()\-_])[\w\d\-.!@#$%^&*()]{6,}$/;
export const uriRegEx = /[\w\d-]{4,}$/;
export const emailRegEx =
  /^([a-zA-Z0-9_+\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/;
export const urlRegEx =
  /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi;
